import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { SequenceTable } from "./SequenceTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  paginationSet,
  showDialog,
  showErrorDialog,
  useForceUpdate,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import {
  fetchNumberSequence,
  selectNumberSequence,
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
} from "./businessGroupSlice";
// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { NumberSequenceCreate } from "./NumberSequenceCreate";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const NumberSequence = ({
  active,
  value,
  setValue,
  fields,
  setFields,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectNumberSequence);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const forceUpdate = useForceUpdate();

  const user = useSelector(selectUser);
  const [force, setForce] = useState(false);
  const [dataRow, setDataRow] = useState(null);

  // Filter
  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setForce(false);
    }
  }, [force]);

  const handleSearch = async () => {
    let params = {};
    fields.forEach((item) => {
      params[item.params] = item.value;
    });
    params.is_enable = value === 0 ? "Y" : "N";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    console.log(params, "params");

    try {
      const response = await dispatch(fetchNumberSequence(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      params.is_enable = value === 0 ? "Y" : "N";
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchNumberSequence(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // paket filter
  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "sequence_name",
      label: "Name",
      show: "Y",
      editor: "text",
    },
  ]);

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });
    setTypeOptions(result);

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  // paket filter bawah

  // Func Create
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <Button
              className="btn btn-primary my-btn-primary-dark text-bold mb-5"
              onClick={handleShow}
            >
              New Sequence
            </Button>
            {fields.map((field, idx) => {
              return (
                <div key={`${field}-${idx}`}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={1}>
                      {idx === 0 && <b>Search By</b>}
                    </Form.Label>

                    <Col sm={3}>
                      {fields[idx].add === "N" && (
                        <Select
                          // isClearable={true}
                          options={data_filter}
                          value={getValueType(field.params, typeOptions)}
                          placeholder="Select Field"
                          // onChange={handleTypeChange}
                          onChange={(e) => handleTypeChange(idx, e)}
                        />
                      )}
                      {fields[idx].add === "Y" && (
                        <Form.Control
                          type="text"
                          value={fields[idx].label}
                          disabled
                        />
                      )}
                    </Col>
                    <Col sm={3}>
                      {field.editor === "text" && (
                        <Form.Control
                          type="text"
                          placeholder="Enter text"
                          value={field.value || ""}
                          onChange={(e) => handleRemarkChange(idx, e)}
                        />
                      )}
                    </Col>
                    <Col sm={3} className=" m-0 p-0">
                      {fields.length !== 1 && (
                        <div
                          className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                          onClick={() => handleRemove(idx)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-light">
                            <SVG
                              src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                            />
                          </span>
                        </div>
                      )}

                      {fields.length - 1 === idx && (
                        <Button
                          className="mr-3"
                          variant="outline-primary"
                          onClick={(e) => handleAdd(idx, e)}
                        >
                          Add
                        </Button>
                      )}

                      {fields.length - 1 === idx && (
                        <Button
                          className="mr-3"
                          variant="primary"
                          onClick={handleSearch}
                        >
                          Search
                        </Button>
                      )}
                    </Col>
                  </Form.Group>
                </div>
              );
            })}

            <>
              <Tabs
                value={value}
                onChange={handleChangeTab}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Enabled" />
                <Tab label="Disabled" />
              </Tabs>
              {value === 0 && (
                <SequenceTable
                   data={data === null ? [] : data}
                  page={pageNo}
                  sizePerPage={pageSize}
                  totalSize={totalRecord}
                  onTableChange={handleTableChange}
                  loading={loading}
                  handleSearch={handleSearch}
                />
              )}
              {value === 1 && (
                <SequenceTable
                   data={data === null ? [] : data}
                  page={pageNo}
                  sizePerPage={pageSize}
                  totalSize={totalRecord}
                  onTableChange={handleTableChange}
                  loading={loading}
                  handleSearch={handleSearch}
                />
              )}
            </>
          </CardBody>
        </Card>

        {/* Modal Create */}
        <NumberSequenceCreate
          isOpen={show}
          handleShow={handleShow}
          setShow={setShow}
          dataRow={dataRow}
          setDataRow={setDataRow}
        />
      </div>
    </>
  );
};
